// Ordeno theme scripts: drawers, cart, product page, collection tools and small animations.
(function () {
  var theme = window.theme || { routes: {} };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 990px)');

  /* ---------- Drawers (menu, cart, filters) ---------- */
  var openDrawerEl = null;
  var lastFocus = null;

  function openDrawer(name) {
    var drawer = document.querySelector('[data-drawer="' + name + '"]');
    if (!drawer) return false;
    if (openDrawerEl && openDrawerEl !== drawer) closeDrawer();
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    document.querySelectorAll('[data-drawer-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    openDrawerEl = drawer;
    var focusTarget = drawer.querySelector('.drawer__close');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 50);
    return true;
  }

  function closeDrawer() {
    if (!openDrawerEl) return;
    var name = openDrawerEl.getAttribute('data-drawer');
    openDrawerEl.classList.remove('is-open');
    openDrawerEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    document.querySelectorAll('[data-drawer-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    openDrawerEl = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var name = opener.getAttribute('data-drawer-open');
      if (name === 'cart' && (!theme.cartDrawer || theme.isCartPage)) return; // follow the link to /cart
      if (openDrawer(name)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  // Close the mobile menu when switching to the desktop layout
  desktop.addEventListener && desktop.addEventListener('change', function (e) { if (e.matches && openDrawerEl && openDrawerEl.getAttribute('data-drawer') === 'menu') closeDrawer(); });

  // Desktop dropdowns: close others when one opens, and when clicking outside
  var dropdowns = document.querySelectorAll('[data-dropdown]');
  dropdowns.forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) dropdowns.forEach(function (o) { if (o !== d) o.open = false; }); });
  });
  document.addEventListener('click', function (e) { dropdowns.forEach(function (d) { if (!d.contains(e.target)) d.open = false; }); });

  /* ---------- Toast ---------- */
  var toastEl = document.querySelector('[data-toast]');
  var toastTimer;
  function toast(message) {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3000);
  }

  /* ---------- Cart ---------- */
  function setCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; });
  }

  function refreshCartDrawer() {
    return fetch(theme.routes.root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        var current = document.getElementById('CartDrawer');
        if (!html || !current) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartDrawer');
        if (!fresh) return;
        current.querySelector('.drawer__panel').innerHTML = fresh.querySelector('.drawer__panel').innerHTML;
        var countEl = fresh.querySelector('[data-cart-count-value]');
        if (countEl) setCount(parseInt(countEl.textContent, 10) || 0);
      });
  }

  function afterCartChange(openIt) {
    if (theme.isCartPage) { window.location.reload(); return Promise.resolve(); }
    if (!theme.cartDrawer || !document.getElementById('CartDrawer')) {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); toast('Added to your cart'); });
    }
    return refreshCartDrawer().then(function () { if (openIt) openDrawer('cart'); });
  }

  function addToCart(body, button, form) {
    if (button) { button.classList.add('is-loading'); button.disabled = true; }
    return fetch(theme.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message || 'Could not add this item'); return; }
        return afterCartChange(true);
      })
      .catch(function () { if (form) form.submit(); else toast('Could not add this item'); })
      .finally(function () { if (button) { button.classList.remove('is-loading'); button.disabled = false; } });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form], [data-quick-add]')) return;
    if (!window.fetch) return;
    e.preventDefault();
    addToCart(new FormData(form), form.querySelector('[type=submit]'), form);
  });

  // Suggestions in the cart sit inside the cart form, so they add through a plain button instead of their own form.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var body = new FormData();
    body.append('id', btn.getAttribute('data-variant-id'));
    body.append('quantity', '1');
    addToCart(body, btn);
  });

  function changeLine(line, quantity) {
    var body = JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, parseInt(quantity, 10) || 0) });
    return fetch(theme.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body })
      .then(function () { return afterCartChange(false); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    changeLine(btn.getAttribute('data-line'), btn.getAttribute('data-qty'));
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-input]');
    if (input) changeLine(input.getAttribute('data-line'), input.value);
  });

  /* ---------- Product page ---------- */
  // Same output as Liquid's money filter, using the shop's money format (e.g. "€{{amount_with_comma_separator}}").
  var formatMoney = function (cents) {
    var format = (window.theme && theme.moneyFormat) || '{{amount}}';
    var parts = (cents / 100).toFixed(2).split('.');
    var group = function (sep) { return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals': return group(',');
        case 'amount_with_comma_separator': return group('.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator': return group('.');
        case 'amount_with_apostrophe_separator': return group("'") + '.' + parts[1];
        case 'amount_with_space_separator': return group(' ') + ',' + parts[1];
        default: return group(',') + '.' + parts[1];
      }
    });
  };

  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = track ? track.children : [];
    var dots = gallery.querySelectorAll('.gallery__dot');
    var thumbs = gallery.querySelectorAll('.gallery__thumb');
    var count = gallery.querySelector('[data-gallery-count]');
    if (!track || slides.length < 2) return;

    function setActive(i) {
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    function goTo(i, smooth) {
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false || reduceMotion ? 'auto' : 'smooth' });
      setActive(i);
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        setActive(Math.round(track.scrollLeft / track.clientWidth));
        ticking = false;
      });
    }, { passive: true });
    gallery.addEventListener('click', function (e) {
      var go = e.target.closest('[data-gallery-go]');
      if (go) goTo(parseInt(go.getAttribute('data-gallery-go'), 10));
    });
    gallery.goToMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) { goTo(i); return true; }
      }
      return false;
    };
    gallery.goToStart = function () { goTo(0); };
    var start = parseInt(gallery.getAttribute('data-start'), 10) || 0;
    if (start > 0) requestAnimationFrame(function () { goTo(start, false); });
  });

  document.querySelectorAll('[data-product]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var button = root.querySelector('[data-add-button]');
    var priceWrap = root.querySelector('[data-price-wrap]');
    var gallery = root.querySelector('[data-gallery]');
    var sticky = root.querySelector('[data-sticky-buy]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickyButton = root.querySelector('[data-sticky-buy-button]');

    // Variant photos that are not in the gallery (set colour combinations) replace the first photo.
    var firstImg = gallery && gallery.querySelector('.gallery__slide img');
    var firstThumb = gallery && gallery.querySelector('.gallery__thumb img');
    function showVariantMedia(variant) {
      if (gallery.goToMedia && gallery.goToMedia(variant.featured_media.id)) return;
      var img = variant.featured_media.preview_image;
      if (!firstImg || !img || !img.src) return;
      var src = img.src + (img.src.indexOf('?') > -1 ? '&' : '?') + 'width=';
      firstImg.removeAttribute('srcset');
      firstImg.src = src + 1400;
      firstImg.alt = variant.featured_media.alt || firstImg.alt;
      if (firstThumb) { firstThumb.removeAttribute('srcset'); firstThumb.src = src + 180; }
      if (gallery.goToStart) gallery.goToStart();
    }
    var initial = product.variants.find(function (v) { return String(v.id) === new URLSearchParams(window.location.search).get('variant'); });
    if (initial && initial.featured_media && gallery) showVariantMedia(initial);

    root.querySelectorAll('[data-option]').forEach(function (input) {
      input.addEventListener('change', function () {
        var selected = [];
        root.querySelectorAll('[data-option]:checked').forEach(function (el) {
          var pos = Number(el.dataset.option);
          selected[pos - 1] = el.value;
          var label = root.querySelector('[data-option-label="' + pos + '"]');
          if (label) label.textContent = el.value;
        });
        var variant = product.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
        if (!variant) return;
        idInput.value = variant.id;
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Add to cart' : 'Sold out';
        if (stickyButton) stickyButton.disabled = !variant.available;
        var html = '<div class="price' + (variant.compare_at_price > variant.price ? ' price--sale' : '') + '"><span class="price__current">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
        }
        priceWrap.innerHTML = html + '</div>';
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
        if (variant.featured_media && gallery) showVariantMedia(variant);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    });

    // Quantity stepper
    root.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentElement.querySelector('input');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
      });
    });

    // Sticky buy bar on phones: shows once the main button has scrolled out of view
    if (sticky && button) {
      var updateSticky = function () { sticky.classList.toggle('is-visible', button.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', updateSticky, { passive: true });
      updateSticky();
      stickyButton.addEventListener('click', function () { button.click(); });
    }
  });

  /* ---------- Collection: sort ---------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Footer: collapsed columns on phones ---------- */
  var footerCols = document.querySelectorAll('[data-footer-col]');
  function syncFooter() { footerCols.forEach(function (d) { d.open = window.innerWidth >= 750; }); }
  if (footerCols.length) { syncFooter(); window.matchMedia('(min-width: 750px)').addEventListener('change', syncFooter); }

  /* ---------- Announcement rotation ---------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var items = bar.querySelectorAll('.announcement__item');
    if (items.length < 2 || reduceMotion) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal, .section__head, .step, .feature, .faq__item, .newsletter, .split__intro');
  if ('IntersectionObserver' in window && !reduceMotion) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    revealEls.forEach(function (el, i) {
      el.classList.add('reveal');
      el.style.transitionDelay = (i % 4) * 60 + 'ms';
      observer.observe(el);
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Hero tilt (mouse only; touch devices get a gentle CSS sway) ---------- */
  var stage = document.querySelector('[data-tilt]');
  if (stage && !reduceMotion && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var area = stage.closest('.hero') || stage;
    var frame = 0;
    area.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect();
      var x = Math.max(-1, Math.min(1, (e.clientX - r.left - r.width / 2) / (r.width / 2)));
      var y = Math.max(-1, Math.min(1, (e.clientY - r.top - r.height / 2) / (r.height / 2)));
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        stage.classList.add('is-tilting');
        stage.style.setProperty('--ry', (x * 10).toFixed(2) + 'deg');
        stage.style.setProperty('--rx', (-y * 7).toFixed(2) + 'deg');
        stage.style.setProperty('--px', (x * 16).toFixed(1) + 'px');
        stage.style.setProperty('--py', (y * 12).toFixed(1) + 'px');
        stage.style.setProperty('--sx', (50 - x * 35).toFixed(0) + '%');
        stage.style.setProperty('--sy', (35 - y * 30).toFixed(0) + '%');
      });
    });
    area.addEventListener('pointerleave', function () {
      cancelAnimationFrame(frame);
      stage.classList.remove('is-tilting');
      ['--rx', '--ry', '--px', '--py', '--sx', '--sy'].forEach(function (p) { stage.style.removeProperty(p); });
    });
  }
})();
